<template>
  <div class="w3-theme-light">
    <span>
      <button type="button" @click="viewUserFeed()" class="w3-button w3-text-theme w3-hover-white" style="padding-left: 3px; padding-right:0px">
        {{user.name}}
      </button>
      <trust-button v-if="isAuthenticated" v-bind:user="user" />
    </span>
  </div>
</template>

<script>
  import UserHeader from "./UserHeader.ts";

  export default UserHeader;
</script>
